import { useTheme } from '@mui/material';
const useBlacklistWhitelistStyles = () => {
    const theme = useTheme();
    return {
        mainContainerStyles: {
            width: '100%'
        },
        tabsSwitchContainerStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 2
        },
        buttonStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 150,
            py: '6px',
            px: 2,
            borderRadius: '99px',
            transition: '0.2s all',
            background: theme.palette.background.neutral,
            color: theme.palette.text.disabled,
            h6: {
                fontWeight: 500
            },
            '&:hover,&.active': {
                background: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                zIndex: 1
            }
        },
        contentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 1.5,
            gap: 1
        },
        toolbarStyles: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1.5
        },
        filterSectionStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 1.5
        },
        searchbarStyles: {
            gap: 1,
            input: {
                fontSize: 13,
                fontWeight: 600,
                color: theme.palette.text.primary,
                '&::placeholder': {
                    color: theme.palette.text.primary
                }
            }
        },
        addVehicleButtonStyles: {},
        actionContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1.5
        },
        imageStyles: {
            width: 40,
            height: 40,
            aspectRatio: 1 / 1,
            borderRadius: '6px',
            objectFit: 'cover',
            backgroundRepeat: 'no-repeat',
            alignSelf: 'center',
        },
    };
};
export default useBlacklistWhitelistStyles;
